// extracted by mini-css-extract-plugin
export default {"button":"downloadResume_button__ao5kj","darkButton":"downloadResume_darkButton__o76p7"};